var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",staticClass:"process-chart-viewer-dialog",attrs:{"appendToBody":false,"title":_vm.title,"size":"large_large","width":_vm.params.width ? _vm.params.width : '',"height":_vm.params.height ? _vm.params.height : ''}},[_c('flow-chart-viewer',{attrs:{"params":_vm.params,"parentObj":this}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d48d062","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/public-dialog/process-chart-viewer.vue
// module id = 1098
// module chunks = 0 1